import http from '@/utils/http'
import convert from '@/utils/model-convert'
import {FormArgument} from '@/models/customer-good'

const TAB_URL = '/rest/tourist/shop/advertisement?type=1'
const TAB_TO_URL = '/rest/tourist/shop/advertisement?type=3'
const SCORE_URL = '/rest/tourist/shop/customer-score-goods/pool/{type}'
const MEES_URL = '/rest/tourist/tourist-feedback'
const MEES_LOGIN_URL = '/rest/customer/feedback/customer-messa'
const ID_URL = '/rest/tourist/shop/customer-score-goods/{id}'
const CASE_URL = '/rest/tourist/shop/product-cases'
const STATE_URL = '/rest/tourist/customer-home-article'
const STATE_ID_URL = '/rest/tourist/customer-home-article/{id}'
const SHARE_URL = '/rest/customer/shop/customer-score/share'
const READ_URL = '/rest/customer/shop/customer-score/read'
const INDUS = '/rest/tourist/marketing-service'
const INDUS_GET_URL = '/rest/tourist/marketing-service/{id}'
const JOIN_URL = '/rest/tourist/recruitment'
const JOINTYPE_URL = '/rest/tourist/recruitment/positionType'

export default {
  viewpager (cb) {
    http.get(TAB_URL).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  viewpagerTo (cb) {
    http.get(TAB_TO_URL).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getPositionType (cb) {
    http.get(JOINTYPE_URL).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getJoinList ({page, pageSize, positionType}, cb) {
    http.get(JOIN_URL, {
      params: {
        page: page,
        pageSize: pageSize,
        positionType: positionType,
        status: 1
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  getIndus ({page, pageSize}, cb) {
    http.get(INDUS, {
      params: {
        page: page,
        pageSize: pageSize
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  list ({type}, cb) {
    http.get(SCORE_URL.replace('{type}', type)).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  productGood ({id}, cb) {
    http.get(ID_URL.replace('{id}', id)).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  case ({typeId, page, pageSize}, cb) {
    http.get(CASE_URL, {
      params: {
        typeId: typeId,
        page: page,
        pageSize: pageSize
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  create ({form}, cb) {
    let postData = convert.toStringify(form, FormArgument)
    http.post(MEES_URL, postData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  createLogin ({form}, cb) {
    let postData = convert.toStringify(form, FormArgument)
    http.post(MEES_LOGIN_URL, postData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  stateList ({page, pageSize}, cb) {
    http.get(STATE_URL, {
      params: {
        page: page,
        pageSize: pageSize
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  sharese (cb) {
    http.get(SHARE_URL).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  readsh (cb) {
    http.get(READ_URL).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  get ({id}, cb) {
    http.get(INDUS_GET_URL.replace('{id}', id)).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  stateGet ({id}, cb) {
    http.get(STATE_ID_URL.replace('{id}', id)).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/customer-good.js